var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":"primary"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{domProps:{"innerHTML":_vm._s(`mdi-rotate-3d-variant`)}}),_vm._v(" "+_vm._s(_vm.$t('button.refresh'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }